import React, {Fragment, useEffect} from 'react'
import DrawingRegister from '../../components/DrawingRegister/DrawingRegister'

const Drawing_Register = props => {
	const {moduleSeq} = props
	const store = require('store')

	useEffect(() => {
		store.set("current_module_seq", moduleSeq)
	}, [])

	return (
		<Fragment>
			<DrawingRegister />
		</Fragment>
	)
}

export default Drawing_Register
